import React from "react"
import { RenderElementProps } from "slate-react"

const HeadingLarge = ({ children, attributes }: RenderElementProps) => {
    return (
        <div
            {...attributes}
            className="font-gibson mb-5 text-5xl font-semibold last:mb-0 sm:text-5xl/5xl lg:mb-7 lg:text-7xl xl:text-8xl"
        >
            {children}
        </div>
    )
}

export default HeadingLarge
